// extracted by css-extract-rspack-plugin
export default {"container":"_891618c9","logo":"_b9cb30a5","navPrivateClient":"_b212ab03","dark":"_def3bf72","black":"_25b3c1c9"};